import { type DocumentEditor } from "@syncfusion/ej2-react-documenteditor";

const password = "123";

export const enforceDocumentProtection = async (
  documentEditor: DocumentEditor,
  documentVersionId: number,
  isReadOnlyStatus: boolean,
  isActiveUser: boolean,
) => {
  if (isReadOnlyStatus || !isActiveUser) {
    documentEditor.isReadOnly = true;
  } else {
    documentEditor.editor.stopProtection(password);
    documentEditor.isReadOnly = false;

    // Load local track changes settings
    const enableTrackChanges =
      localStorage.getItem(`trackChanges${documentVersionId}`) === "true";
    documentEditor.enableTrackChanges = enableTrackChanges;
  }
};
